export default __webpack_public_path__ + "static/media/upload.cde21269.svg";